import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ClassSetupDataProps = {
  shortName?: string;
  className?: string;
  studentList?: { id: string; voiceName: string }[];
};

export type SessionStore = {
  // State
  token?: string;
  classSetupData?: ClassSetupDataProps;
  isSetupSubmitted: boolean;

  // Actions
  setToken: (token: string) => void;
  resetSession: () => void;
  setIsSetupSubmitted: (isSetupSubmitted: boolean) => void;
  setClassSetupData: (classSetupData?: ClassSetupDataProps) => void;
};

export const sessionStore = create<SessionStore>()(
  persist(
    (set) => ({
      // Initial state
      token: undefined,
      isSetupSubmitted: false,
      classSetupData: undefined,

      // Actions
      setToken: (token: string) => set({ token }),
      resetSession: () => set({ token: undefined, isSetupSubmitted: false, classSetupData: undefined }),
      setIsSetupSubmitted: (isSetupSubmitted: boolean) => set({ isSetupSubmitted }),
      setClassSetupData: (classSetupData?: ClassSetupDataProps) => set({ classSetupData }),
    }),
    {
      name: 'sessionStorage',
    },
  ),
);
